import { FormControlLabel, styled } from "@mui/material";

export const StyledFormikCheckbox = {
    Checkbox: styled(FormControlLabel)(({ theme }) => ({
        marginLeft: -10,
    })),
}